<div class="progress-bar">
  <div class="progress" [ngStyle]="{width: progress + '%'}"></div>
</div>
<div class="steps">
  <span>{{'Paso ' | translate}}{{actualStep}}{{' de ' | translate}}{{totalStep}}<strong>{{' Bancos seleccionados' | translate}}</strong></span>
</div>